import React, {PureComponent} from 'react';

import OffersExamples from './OffersExamples.jsx';

import './OffersExamples.scss';

export default class OffersExamplesPurchase extends PureComponent {
  render() {
    const metaTitle = "Achats : nos exemples de mandats";
    const metaDescription = "Retrouvez les différents types de mandats Achat déjà postés sur notre plateforme : " +
      "management de transition, interim management, groupe international, ETI, etc.";

    return <OffersExamples
      metaDescription={metaDescription}
      metaTitle={metaTitle}
      universeCode="purchase"
      title="Les mandats Achats que vous auriez pu recevoir :"
    />;
  }
}
